import { Timestamp } from "firebase/firestore/lite";
import { DbBusinessReview } from "../business/models";

export interface DbBusinessWaitlist {
  id: string;
  name: string;
  description?: string;
  deposit_amount?: number;
  created_at: FirestoreTimestamp;
  updated_at: FirestoreTimestamp;
  waitlist_status: DbWaitlistStatus;
  custom_hours_enabled: boolean;
  waitlist_hours: any;
  request_guest_count: boolean;
  guest_count_question?: string;
  max_guest_capacity?: number;
  provide_estimated_time: boolean;
  estimated_time?: number;
  states: DbWaitlistState[];
  summary?: DbBusinessWaitlistSummary;
  turn_over_time?: number;
  additional_infos?: DbWaitlistAdditionalInfo[];
  table_sections: DbWaitlistTableSection[];
  table_combinations: any;
  queueCount: number;
  tokenCount: number;
  joined: boolean;
}

export enum DbWaitlistState {
  pending = "pending",
  arrived = "arrived",
  serving = "serving",
  completed = "completed",
  cancelled = "cancelled",
}

export interface DbWaitlistTableSection {
  name: string;
  tables: DbWaitlistTable[];
}
export interface DbWaitlistTable {
  id: string;
  name: string;
  capacity: number;
  min_capacity: number;
  enabled: boolean;
}

export interface DbWaitlistAdditionalInfo {
  id: string;
  type: DbWaitlistAdditionalInfoType;
  question: string;
  options: string[];
  selected_number: number | null;
  selected_option: string | null;
  selected_text: string | null;
  is_for_business: boolean;
  is_required: boolean;
}

export interface DbBusinessWaitlistSummary {
  date: Timestamp;
  token_count: number;
  serving_queue: ServingQueue[];
  waiting_queue: DbWaitlistQueue[];
}

export interface ServingQueue {
  token: string;
  table_ids: string[];
  serving_start_time: FirestoreTimestamp;
}

export interface ServingEntry {
  table_id: string;
  serving_start_time: FirestoreTimestamp;
}

export interface DbWaitlistQueue {
  token: string;
  guest_count: number;
}

export enum DbWaitlistStatus {
  enable = "enable",
  disable = "disable",
  deleted = "deleted",
}

export enum DbWaitlistAdditionalInfoType {
  number_input = "number_input",
  options = "options",
  text = "text",
}
export interface DbWaitlistBooking {
  id: string;
  business_id: string;
  user_id: string;
  waitlist_id: string;
  waitlist_booking_id: string;
  created_at: FirestoreTimestamp;
  updated_at: FirestoreTimestamp;
  deposit_amount?: number;
  status: DbWaitlistBookingStatus;
  business_payment_amount?: number;
  payment: any;
  token_number: string;
  platform_fees?: number;
  additional_infos: DbWaitlistAdditionalInfo[];
  turn_over_time?: number;
  guest_count?: number;
  share_id: string;
  serving_started_at: FirestoreTimestamp;
  serving_completed_at: FirestoreTimestamp;
  serving_duration: number;
  review?: DbBusinessReview;
}

interface FirestoreTimestamp {
  _seconds?: number;
  seconds?: number;
  _nanoseconds?: number;
  nanoseconds?: number;
}

export interface APIWaitlistBooking {
  additional_infos: DbWaitlistAdditionalInfo[];
  business_id: string;
  business_payment_amount?: number;
  created_at: FirestoreTimestamp;
  created_at_iso_date: string;
  deposit_amount?: number;
  guest_count?: number;
  id: string;
  platform_fees?: number;
  review?: DbBusinessReview;
  requires_payment_transaction: boolean;
  serving_completed_at: FirestoreTimestamp;
  serving_duration: number;
  serving_started_at: FirestoreTimestamp;
  share_id: string;
  status: DbWaitlistBookingStatus;
  table_ids: string[];
  token_number: string;
  updated_at: FirestoreTimestamp;
  user_id: string;
  waitlist_id: string;
}

export enum DbWaitlistBookingStatus {
  pending = "pending",
  arrived = "arrived",
  serving = "serving",
  completed = "completed",
  cancelled = "cancelled",
}

export enum WaitlistTableType {
  enabled = "enabled",
  applicable = "applicable",
  suggested = "suggested",
  all_non_suggested = "allNonSuggested",
  non_assignable_empty = "nonAssignableEmpty",
}

export interface Table {
  tableId: string;
  name: string;
  minGuests: number;
  maxGuests: number;
  assignedGuests: QueueEntry[];
}

export interface QueueEntry {
  tokenNumber: string;
  guestCount: number;
  tableIds: string[];
}

export interface Bucket {
  name: string;
  minGuests: number;
  maxGuests: number;
  tables: Table[];
  totalQueueSize: number;
  loadFactor: number;
  earliestAvailability: (tableAvailability: Record<string, Date>) => Date;
}
